
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDeviceType } from '@/hooks/useDeviceType';
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar';
import AppSidebar from './AppSidebar';
import Navbar from './Navbar';
import BottomTabBar from './BottomTabBar';
import { useAuth } from '@/context/AuthContext';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { isMobile, isTablet, isDesktop } = useDeviceType();

  const handleLogout = React.useCallback(async () => {
    await logout();
    navigate('/');
  }, [logout, navigate]);
  
  // Sidebar defaults: collapsed on tablet, open on desktop, hidden (sheet) on mobile
  const sidebarDefaultOpen = isDesktop;
  
  return (
    <SidebarProvider defaultOpen={sidebarDefaultOpen}>
      <div className="flex min-h-screen w-full max-w-full overflow-x-hidden">
        {/* Main platform supports desktop, tablet, and mobile */}
        {user && <AppSidebar userRole={user.role} />}
        
        <SidebarInset className="flex-1 min-w-0 w-full bg-background">
          <div className="flex flex-col min-h-screen w-full">
            <Navbar user={user} onLogout={handleLogout} />

            <main className={`
              flex-1 w-full max-w-full overflow-x-hidden
              ${isMobile ? 'pb-24' : isTablet ? 'pb-20' : ''}
            `}>
              <div className="w-full max-w-full overflow-x-hidden">
                {children}
              </div>
            </main>
          </div>
        </SidebarInset>
        
        {/* Mobile & Tablet Bottom Tab Bar */}
        <BottomTabBar />
      </div>
    </SidebarProvider>
  );
};

export default Layout;
